import { Collapse, Modal, Toast, Dropdown, Tab } from 'bootstrap';

/**
 *  Import JS
 *  files from Mindstyle Core plugin
 */
import '../../../../plugins/wpg-mindstyle-core/src/assets/js/components/load-more.js';

/**
 *  files from theme
 */

import mainNav from './components/mainNav';
import stickyBar from './components/stickyBar';

try {
  // safety loader
  if (!window.$) {
    window.$ = window.jQuery = require('jquery');

  }

  document.addEventListener('DOMContentLoaded', () => {
    mainNav();
  });

  jQuery(document).ready(function($) {
    stickyBar();
  });
}
catch (e) {}
